import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled"
import {ReactComponent as Icon} from "../../assets/SignatureButtonIcon.svg";

const ActionButtonWrapper = styled.div`

    display: flex;
    align-items: center;
    justify-content: center;
      /* Rectangle 7 */
    width: 72px;
    height: 24px;
    
    /* default/shade/white */
    background: #FFFFFF;
    /* default/gray/500 */
    border: 1px solid #A0AEC0;
    box-sizing: border-box;
    border-radius: 4px;
    
    cursor:pointer;
`;

function SignatureActionButton({onClick, signatureImage}) {
    return (
        <ActionButtonWrapper onClick={onClick}>
            {
                signatureImage
                    ? <img src={signatureImage} style={{height: "100%", width: "100%"}} alt={"Signature"}/>
                    : <Icon/>
            }
        </ActionButtonWrapper>
    );
}

SignatureActionButton.propTypes = {};
SignatureActionButton.defaultProps = {};

export default SignatureActionButton;
